import { COLORS } from '@/app/providers/theme';
import styled from '@emotion/styled';
import { Typography, Box } from '@mui/material';

const Counter = ({ currentCount = 0, totalCount = 0 }: any) => {
  return (
    <CounterBox>
      <Typography>
        Showing {currentCount} of {totalCount} records
      </Typography>
    </CounterBox>
  );
};

const CounterBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  margin: '10px 0',
  color: `${COLORS.secondary}`
}));

export default Counter;
